import { API, Helpers, Router } from '../Helpers';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Loader from '../Loader';
import FiltersForm from '../ToursIndex/FiltersForm';
import _ from 'lodash';
import { ReturnToFilters } from '../Shared';

export default class ToursColumn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cart: this.props.data.cart,
            impressions: [],
            tours: this.props.data.tours,
            location: _.find(this.props.data.locations.data, (_location) => _location.slug === "bahamas" ),
            tourRating: !_.isEmpty(this.props.data.request.rating) ? (parseInt(this.props.data.request.rating)) : 0,
            tourCategories: [],
            applyFilters: false,
            min_price: !_.isEmpty(this.props.data.request.min_price) ? (parseInt(this.props.data.request.min_price)) : undefined,
            max_price: !_.isEmpty(this.props.data.request.max_price) ? (parseInt(this.props.data.request.max_price)) : undefined,
            // min_duration: !_.isEmpty(this.props.data.request.min_duration) ? (parseInt(this.props.data.request.min_duration)) : undefined,
            // max_duration: !_.isEmpty(this.props.data.request.max_duration) ? (parseInt(this.props.data.request.max_duration)) : undefined,
            show_filters_accordion: false,
            sort_by: this.props.data.sort_by,
            search: '',
            show_loader: false,
            form_id: uniqid(),
            specific_tours: this.props.data.specific_tours || false
        };
        
        this.changeDurationRange = this.changeDurationRange.bind(this);
        this.changePriceRange = this.changePriceRange.bind(this);
        this.changeRating = this.changeRating.bind(this);
        this.changeTourCategories = this.changeTourCategories.bind(this);
        this.findLocationBackground = this.findLocationBackground.bind(this);
        this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
        this.findTourListingCtaText = this.findTourListingCtaText.bind(this);
        this.generateProductUrl = this.generateProductUrl.bind(this);
        this.inCart = this.inCart.bind(this);
        this.nextCount = this.nextCount.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.loadMoreTours = this.loadMoreTours.bind(this);
        this.measureProductClick = this.measureProductClick.bind(this);
        this.measureProductImpression = this.measureProductImpression.bind(this);
        this.toCount = this.toCount.bind(this);
        this.toggleFiltersAccordion = this.toggleFiltersAccordion.bind(this);
        this.urlParams = this.urlParams.bind(this);
        // this.tourFiltersUrlParams = this.tourFiltersUrlParams.bind(this);
        this.loadToursWithNewParams = this.loadToursWithNewParams.bind(this);
        this.getLocationOptions = this.getLocationOptions.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleFiltersFormSubmit = this.handleFiltersFormSubmit.bind(this);
        this.resetSearch = this.resetSearch.bind(this);
    }

    // componentDidMount() {
    //     // console.log(this.getLocationOptions());
    //     // console.log("props", this.props.data);
    //     console.log("state location", this.state.location);
    //     this.changeLocation(this.state.location);
    // }

    getLocationOptions()
    {
        const location_groups = _.groupBy(this.props.data.locations.data, 'country_name');
        const countries = _.keysIn(location_groups);
        
        let location_options = [];
        
        _.forEach(countries, (country) => {
            
            let options = [];
            
           _.forEach(location_groups[country], (location) => {
               
               location.label = location.region;
               
                if (_.isEmpty(location.label))
                {  
                    location.label = location.country_name;
                }
               
                location.value = location.slug;
            
                options.push(location);
            });
            
            location_options.push({
                label: country,
                options: _.sortBy(options, ['label'])
            });
        });
        
        return _.sortBy(location_options, ['label']);
    }

    changeLocation(location)
    {
        //console.log("changeLocation", location);
        
        this.setState({
            location: location
        }, () => {
            this.updateTours();
        });
    }

    updateTours()
    {
        //console.log("updateTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams();
        
        //console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                //console.log("updateTours response", response);
                
                this.setState({
                    tours: response,
                    show_loader: false
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            show_loader: true
        }, () => 
        {
            API.get(onResponse, router.url('api.tours.index', payload));
        });
    }
    
    changeDurationRange(form_id, slide_event)
    {        
        this.setState({
            min_duration: slide_event.from,
            max_duration: slide_event.to,
        }, () => 
        {
            // this.submitFiltersForm(form_id);
        });
    }
    
    changePriceRange(form_id, slide_event)
    {
        //console.log("changePriceRange", slide_event);
        
        //console.log(slide_event.from);
        //console.log(slide_event.to);
        
        this.setState({
            min_price: slide_event.from,
            max_price: slide_event.to,
        }, () => 
        {
            // this.submitFiltersForm(form_id);
        });
    }

    changeRating(event){
        this.setState({tourRating: event.target.value});
    }

    changeTourCategories(event){
        let {tourCategories} = this.state
        let value = event.target.value

        // Check if value exists in array
        if (tourCategories.indexOf(value) !== -1) {
            let i = tourCategories.indexOf(value)
            tourCategories.splice(i, 1)
        } else {
            tourCategories.push(value)
        }    
    }
    
    findProductCoverPhoto(tour)
    {
        if (!_.isEmpty(tour.cover_photo))
        {
            return tour.cover_photo.medium;
        }
        
        return '/images/placeholder-16-9.jpg';
    }
    
    findLocationBackground()
    {
        if (!_.isEmpty(this.props.data.location.background))
        {
            return this.props.data.location.background;
        }
        
        let default_location_background = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'default_location_background'; });
        
        if (!_.isEmpty(default_location_background))
        {
            return default_location_background.value;
        }
    }
    
    findTourListingCtaText()
    {
        let tour_listing_cta_text = _.find(this.props.data.active_site.settings.data, (_setting) => { return _setting.key == 'tour_listing_cta_text'; });
        
        if (!_.isEmpty(tour_listing_cta_text))
        {
            return tour_listing_cta_text.value;
        }
    }
    
    // generateProductUrl(tour)
    // {
    //     const router = Router(this.props.data.routes);
        
    //     let params = {
    //         domain: this.props.data.active_site.domain, 
    //         id: tour.id, 
    //         tour_slug: tour.slug
    //     };
        
    //     if (!_.isEmpty(this.state.location))
    //     {
    //         if (!_.isEmpty(this.state.location.region_slug))
    //         {
    //             params.region_slug = this.state.location.region_slug;
    //         }
            
    //         if (!_.isEmpty(this.state.location.country_slug))
    //         {
    //             params.country_slug = this.state.location.country_slug;
    //         }
            
    //         console.log("route params", params);
    //         console.log("route params", router.url('tours.show_region', params));
    //         return router.url('tours.show_region', params);
    //     }

        
    //     return router.url('tours.show', params);
    // }
    

    generateProductUrl(tour)
    {
        const router = Router(this.props.data.routes);
        
        let params = {
            domain: this.props.data.active_site.domain, 
            id: tour.id, 
            tour_slug: tour.slug
        };
        
        if (!_.isEmpty(this.state.location))
        {
            if (!_.isEmpty(this.state.location.region_slug) && !_.isNull(this.state.location.region_slug))
            {
                params.region_slug = this.state.location.region_slug;

                if (!_.isEmpty(this.state.location.country_slug) && !_.isNull(this.state.location.country_slug))
                {
                    params.country_slug = this.state.location.country_slug;

                    return this.state.specific_tours ? router.url("specific_tours.show_region", params) : router.url('tours.show_region', params);
                }
            
            }
            
            if (!_.isEmpty(this.state.location.country_slug) && !_.isNull(this.state.location.country_slug))
            {
                params.country_slug = this.state.location.country_slug;

                return this.state.specific_tours ? router.url("specific_tours.show_country", params) : router.url('tours.show_country', params);
            }
            
        }
        
        return this.state.specific_tours ? router.url("specific_tours.show", params) : router.url('tours.show', params);
    }
    
    inCart(tour)
    {
        let index = _.findIndex(this.state.cart.items, (_item) => { return tour.name == _item.name; });
        
        if (index > -1)
        {
            return true;
        }
        
        return false;
    }
    
    measureProductClick(product, position, event)
    {
        //console.log("measureProductClick", product, position, event.target);    
        
        //this.showProductLoader();
        
        //Google Analytics 4
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            'event': "select_item",
            'ecommerce': {
                'items': [{
                    'item_id': product.resmark_id,
                    'item_name': product.name,
                    'item_category': product.categories_string,
                    'price': product.price,
                    'location_id': this.props.data.location.id
                }]
            }
        });
        //Universal Analytics (old)
        dataLayer.push({
            'event': 'productClick',
            'ecommerce': {
                'click': {
                    'actionField': {'list': this.props.data.location.name},
                    'products': [{
                      'name': product.name,
                      'id': product.resmark_id,
                      'price': product.price,
                      'category': product.categories_string,
                      'position': position
                    }]
                }
            }
        });
    }
    
    measureProductImpression(product, position)
    {
        let impressions = [...this.state.impressions];
        
        if (!_.includes(impressions, product.resmark_id))
        {
            //console.log("measureProductImpression", product, position);
            
            impressions.push(product.resmark_id);
            
            this.setState({
                impressions: impressions
            }, () => 
            {
                // Google Analytics 4
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: [{
                            'item_id': product.resmark_id,
                            'item_name': product.name,
                            'item_category': product.categories_string,
                            'location_id': this.props.data.location.id,
                            'price': product.price,
                        }]
                    }
                });
                //Universal Analytics (old)
                dataLayer.push({
                    'event': 'productImpression',
                    'ecommerce': {
                      'currencyCode': 'USD',
                      'impressions': [
                        {
                            'name': product.name,
                            'id': product.resmark_id,
                            'price': product.price,
                            'category': product.categories_string,
                            'list': this.props.data.location.name,
                            'position': position
                        }]
                    }
                });
            });
        }
    }
    
    nextCount()
    {
        if ((this.state.tours.meta.pagination.total - (this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page)) < this.state.tours.meta.pagination.per_page)
        {
            return this.state.tours.meta.pagination.total - this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page;
        }
        
        return this.state.tours.meta.pagination.per_page;
    }
    
    showLoader()
    {
        //console.log("showLoader");
        
        this.setState({
            show_loader: true
        });
    }
    
    loadMoreTours(page)
    {
        //console.log("loadMoreTours");
        
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams(page);
        
        console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                //console.log("loadMoreTours response", response);
                
                let tours = {...this.state.tours};
                
                tours.data = tours.data.concat(response.data);
                tours.meta = response.meta;
                
                this.setState({
                    tours: tours,
                    loading_more_tours: false
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            loading_more_tours: true
        }, () => 
        {
            API.get(onResponse, router.url('api.tours.index', payload));
        });
    }
    
    toCount()
    {
        return this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page < this.state.tours.meta.pagination.total ? this.state.tours.meta.pagination.current_page * this.state.tours.meta.pagination.per_page : this.state.tours.meta.pagination.total;
    }
    
    toggleFiltersAccordion()
    {
        this.setState({
            show_filters_accordion: !this.state.show_filters_accordion
        });
    }
    
    urlParams(page)
    {
        let params = _.omit(this.props.data.request, ['location', 'sort_by', 'page']);
        params = _.assign({ 
            include: 'tags',
            // location: this.state.location.slug,
            sort_by: this.state.sort_by.slug,
            status: 'Published',
            site_id: this.props.data.active_site.id,
        }, params);

        if(this.state.search)
            params = _.assign({ search: this.state.search }, params);
        
        if (page > 1)
        {
            params = _.assign({ page: page }, params);
        }

        if(this.state.applyFilters){
            if(!_.isEmpty(this.state.tourCategories))
            params = _.assign({tour_category: this.state.tourCategories} , params);
            if(this.state.min_price){
                params = _.assign( { min_price: this.state.min_price, max_price: this.state.max_price }, params);
            }
        }
        
        return params;
    }

    loadToursWithNewParams() {
        const router = Router(this.props.data.routes);
        
        let payload = this.urlParams();
        
        console.log("payload", payload);
        
        let onResponse = {
            success: (response) => 
            {
                this.setState({
                    tours: response,
                    show_loader: false
                }, () => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                });
            },
            error: error => 
            {
                console.log('error', error);
            },
            complete: () => 
            {
                console.log('complete');
            }
        }
        
        this.setState({
            show_loader: true
        }, () => 
        {
            API.get(onResponse, router.url('toursRaw', { domain: this.props.data.active_site.domain, ...payload}));
        });
    }

    handleFiltersFormSubmit(html_id)
    {        
        this.setState({
            show_loader: true,
            applyFilters: true
        }, this.loadToursWithNewParams);
    }

    handleSearch(e) {
        e && e.preventDefault();
        this.loadToursWithNewParams();
    }

    resetSearch() {
        this.setState({
            search: '',
        }, this.loadToursWithNewParams )
    }
    
    renderTourListItem(tour, key, tour_listing_cta_text){

        const product_url = this.generateProductUrl(tour);
        const product_cover_photo = this.findProductCoverPhoto(tour);

        let pricingType = _.find(tour.tags.data, (_tag) => { return _tag.tag_group_name === "Pricing Type"; })
        pricingType = !_.isEmpty(pricingType) ? pricingType.name : "per person";

        let duration;
    
        if(!_.isEmpty(tour.date_settings) && !_.isEmpty(tour.date_settings.duration)){
            const matches = tour.date_settings.duration.match(/(\d*\.)?\d+ (hours|hrs) ?(\d+ ?mins)?/i);
            duration = !_.isEmpty(matches) > 0 ? matches[0] : null;
        }

        return (
            <div
                key={key}
                className="col-12 col-md-6 position-relative px-4 mb-5"
            >
                <a href={product_url}>
                    <div className="card z-depth-0 rounded-0">
                        <div
                            className="card-img-top position-relative"
                            style={{
                                backgroundImage:
                                    "url(" +
                                    product_cover_photo +
                                    ")",
                                minHeight: "250px",
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                            }}
                        >
                            {(this.inCart(tour) && !this.props.data.on_property) && (
                                <div
                                    className="position-absolute card z-depth-0 border-black"
                                    style={{
                                        top: "10px",
                                        right: "10px",
                                    }}
                                    tabIndex="0"
                                >
                                    <div className="card-body text-center p-2 black primary-text">
                                        <i className="fa fa-shopping-cart mr-2"></i>
                                        <i className="fa fa-check"></i>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="card-body px-0">
                            <div className="h-100">
                                <div className="line-clamp line-clamp-2">
                                    <h5 className="body-text-color font-weight-bold body-font mb-0 text-uppercase">
                                        {tour.name}
                                    </h5>
                                </div>
                                <p className="text-muted">
                                    {tour.address}
                                </p>

                                <div
                                    className="line-clamp line-clamp-2 body-text-color"
                                    style={{
                                        maxHeight: "100px",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        fontSize: "14px",
                                    }}
                                    dangerouslySetInnerHTML={{__html: tour.short_description}}
                                ></div>
                                <div
                                    className="primary-text text-uppercase font-weight-bold my-4"
                                    style={{ fontSize: "14px" }}
                                >
                                    <span>
                                        from{" "}
                                        {Helpers.formatNoDecimalCurrency(
                                            tour.price
                                        )}
                                    </span>
                                    {!_.isEmpty(duration) && (
                                        <span className="ml-1">
                                            | tour duration:{" "}
                                            {duration}
                                        </span>
                                    )}
                                </div>

                                {!_.isEmpty(
                                    tour_listing_cta_text
                                ) && (
                                    <div>
                                        <button className="btn btn-primary white-text py-2 px-4">
                                            {
                                                tour_listing_cta_text
                                            }
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        )
    }
        
    render() {
        
        const { active_site, location, order_by_options, request, routes, env } = this.props.data;
        const router = Router(routes);
        const tour_listing_cta_text = this.findTourListingCtaText();
        
        return (
            <div className="container">
                {this.state.show_loader && <Loader />}

                <div className="row">
                    <div className="col-12 mt-5">
                        <form onSubmit={this.handleSearch}>
                            <div className="input-group white border border-2p rounded mb-1 p-1">
                                <input
                                value={this.state.search}
                                onChange={(e) => this.setState({
                                    search: e.target.value,
                                })}
                                type="text"
                                name="search"
                                className="form-control form-control-lg border-0 rounded-0"
                                placeholder={"Search tours..."}
                                />
                                <div className="input-group-append">
                                <button
                                    className="btn btn-primary border-0 rounded font-weight-bold px-3 px-lg-5"

                                >
                                    <span className="d-none d-lg-inline">Search</span>
                                    <i className="fa fa-fw fa-search ml-lg-3"></i>
                                </button>
                                </div>
                            </div>
                        </form>
                        <p 
                            style={{ cursor: 'pointer' }}
                            class="primary-text text-right" 
                            onClick={this.resetSearch}
                        >Reset Search</p>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12 col-lg-9">
                        <div className="row">
                            {!_.isEmpty(this.state.tours.data) && this.state.tours.data.map((tour, key) => {
                                return this.renderTourListItem(tour, key, tour_listing_cta_text);
                            })}	
                        </div>	
                            
                        {!_.isEmpty(this.state.tours.data) &&
                            <div className="row">
                                <div className="col-12 col-lg-6 mx-auto">
                                    <div className="text-center">
                                        <div className="mb-2 text-muted"><span className="mr-2">Viewing</span>1 — {this.toCount()} of {this.state.tours.meta.pagination.total}</div>

                                        {
                                            this.state.tours.meta.pagination.current_page < this.state.tours.meta.pagination.total_pages &&
                                            <div>
                                                <button 
                                                    className="btn btn-primary btn-block py-4 mb-2"
                                                    type="button"
                                                    onClick={() => {this.loadMoreTours(this.state.tours.meta.pagination.current_page + 1)}}>

                                                    <ul className="list-inline mb-0 d-flex align-items-center justify-content-center">
                                                        {
                                                            this.state.loading_more_tours &&
                                                            <li className="list-inline-item mr-3">
                                                                <div className="spinner-border spinner-border-md d-block" role="status"></div>
                                                            </li>
                                                        }

                                                        <li className="list-inline-item">
                                                            {
                                                                (this.state.tours.meta.pagination.total - this.toCount()) <= this.state.tours.meta.pagination.per_page ?
                                                                <span className="font-weight-bold font-large">Show all remaining tours<i className="fa fa-lg fa-fw fa-angle-down ml-3"></i></span> :
                                                                <span className="font-weight-bold font-large">Show the next {this.nextCount()} tours<i className="fa fa-lg fa-fw fa-angle-down ml-3"></i></span>
                                                            }
                                                        </li>
                                                    </ul>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ||
                            <div className="div">
                                <div className="col mt-3">
                                    <h2>Sorry! No tours found.</h2>
                                </div>
                            </div>
                        }  
                    </div>

                    {/* filter */}
                    <div className="d-none d-lg-block col-lg-3">
                        <div className="card rounded border">
                            <div className="card-body">
                                <div className="card-header white border-bottom px-0 pt-0">
                                    <form onSubmit={this.showLoader}>
                                        <button type="submit" className="btn btn-outline-dark btn-block text-uppercase d-flex justify-content-between font-smaller border-0 rounded-0">
                                            <div>Reset all filters</div>
                                            <div><i className="fa fa-times"></i></div>
                                        </button>
                                    </form>
                                </div>

                                <FiltersForm 
                                    noRating
                                    noDuration
                                    stopReloadOnSubmit
                                    changeDurationRange={this.changeDurationRange}
                                    changePriceRange={this.changePriceRange}
                                    // changeRating={this.changeRating}
                                    changeTourCategories={this.changeTourCategories}
                                    max_duration={this.state.max_duration}
                                    min_duration={this.state.min_duration}
                                    max_price={this.state.max_price}
                                    min_price={this.state.min_price}
                                    // tourRating={this.state.tourRating}
                                    request={request}
                                    sort_by={this.state.sort_by}
                                    submitFiltersForm={this.handleFiltersFormSubmit}
                                    tours={this.state.tours}
                                />
                                <ReturnToFilters offset={800} scrollToTop={0}/>
                            </div>
                        </div>
                    </div>

                    {/* mobile filter */}
                    <div 
                        id="filtersAccordion" 
                        className={this.state.show_filters_accordion ? "d-lg-none bottombar position-fixed accordion sticky-top bottombar-collapse" : "d-lg-none bottombar position-fixed accordion sticky-top"}
                        style={{ top: this.props.data.on_property ? 0 : '75px'}}
                    >
                        <div className="card rounded-0 h-100">
                            <div className="card-header p-0 d-flex align-items-center">
                                <button 
                                    className="btn btn-flat btn-block" 
                                    type="button" 
                                    id="filterToggle"
                                    data-toggle="collapse" 
                                    data-target="#filtersCollapse"
                                    onClick={() => { this.toggleFiltersAccordion() }}>
                                    <h4 className="mb-0 text-uppercase body-text-color body-font font-weight-bold">Refine Search<i className="fa fa-angle-down rotate-icon ml-3"></i></h4>
                                </button>
                            </div>

                            <div id="filtersCollapse" className="overflow-y-scroll collapse" data-parent="#filtersAccordion">
                                <div className="card-header white border-bottom px-4">
                                    <form onSubmit={this.showLoader}>
                                        <button type="submit" className="btn btn-outline-dark btn-block text-uppercase d-flex justify-content-between font-smaller border-0 rounded-0 px-0">
                                            <div>Reset all filters</div>
                                            <div><i className="fa fa-times"></i></div>
                                        </button>
                                    </form>
                                    </div>
                                <div className="card-body px-4">
                                    <FiltersForm 
                                        noRating
                                        noDuration
                                        stopReloadOnSubmit
                                        changeDurationRange={this.changeDurationRange}
                                        changePriceRange={this.changePriceRange}
                                        // changeRating={this.changeRating}
                                        changeTourCategories={this.changeTourCategories}
                                        max_duration={this.state.max_duration}
                                        min_duration={this.state.min_duration}
                                        max_price={this.state.max_price}
                                        min_price={this.state.min_price}
                                        // tourRating={this.state.tourRating}
                                        request={request}
                                        sort_by={this.state.sort_by}
                                        submitFiltersForm={(arg) => {
                                            // this.toggleFiltersAccordion();
                                            document.querySelector("#filterToggle").click();
                                            this.handleFiltersFormSubmit(arg)
                                        }}
                                        tours={this.state.tours}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
        );
    }
}

if (document.getElementById('toursColumn')) {
    
    const element = document.getElementById('toursColumn');
    const data = Object.assign({}, element.dataset);
        
    //console.log(data.data);
    
    ReactDOM.render(<ToursColumn data={JSON.parse(data.data)} />, document.getElementById('toursColumn'));
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/ToursColumn.js